const environment = {
    // apiUrl: 'https://localhost:44318/api/', // local
    apiUrl: 'https://redeem-chh-api.objective-faraday.119-59-118-127.plesk.page/api/', // VPS

    // apiUrl: 'http://192.168.57.1:8084/api/', // Production
    // apiUrl: 'https://192.168.57.1:8099/api/', // Production
}
export default environment
